module.exports = __webpack_public_path__ + "media/images/salespartner/mv-results_sp-8985174a9f66ce99694b553bf2c0c9b9.svg";